import { useCallback } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Group, Stack, Textarea } from '@mantine/core';
import { DateInput, TimeInput } from '@mantine/dates';
import { Controller, useForm } from 'react-hook-form';
import { z } from 'zod';

const serviceOrderRequestSchema = z.object({
  date: z.string().optional(),
  time: z.string().optional(),
  question1: z.string(),
  question2: z.string(),
  question3: z.string(),
  question4: z.string(),
  question5: z.string(),
  question6: z.string(),
});

export type ServiceOrderRequestFormValues = z.infer<
  typeof serviceOrderRequestSchema
>;

export function ServiceOrderRequestForm({
  initialValues,
  onSubmit,
  onCancel,
}: {
  initialValues?: Partial<ServiceOrderRequestFormValues>;
  onSubmit: (values: ServiceOrderRequestFormValues) => Promise<void>;
  onCancel?: () => void;
}) {
  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<ServiceOrderRequestFormValues>({
    resolver: zodResolver(serviceOrderRequestSchema),
    defaultValues: {
      date: initialValues?.date || undefined,
      time: initialValues?.time || undefined,
      question1: initialValues?.question1 || '',
      question2: initialValues?.question2 || '',
      question3: initialValues?.question3 || '',
      question4: initialValues?.question4 || '',
      question5: initialValues?.question5 || '',
      question6: initialValues?.question6 || '',
    },
  });

  const handleFormSubmit = useCallback(
    async (values: ServiceOrderRequestFormValues) => {
      await onSubmit(values);
    },
    [onSubmit],
  );

  console.log(getValues());
  console.log(errors);

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Stack gap="md">
        <div className="flex gap-2">
          <Controller
            name="date"
            control={control}
            render={({ field }) => (
              <DateInput
                withWeekNumbers
                lang="fr"
                label="Date"
                required
                valueFormat="LL"
                {...field}
              />
            )}
          />
          <Controller
            name="time"
            control={control}
            render={({ field }) => (
              <TimeInput
                label="Heure"
                placeholder="HH:mm"
                type="time"
                {...field}
              />
            )}
          />
        </div>

        <Controller
          name="question1"
          control={control}
          render={({ field }) => (
            <Textarea
              {...field}
              label="Question 1"
              placeholder="Entrez la question 1"
              error={errors.question1?.message}
              minRows={3}
            />
          )}
        />
        <Controller
          name="question2"
          control={control}
          render={({ field }) => (
            <Textarea
              {...field}
              label="Question 2"
              placeholder="Entrez la question 2"
              error={errors.question2?.message}
              minRows={3}
            />
          )}
        />
        <Controller
          name="question3"
          control={control}
          render={({ field }) => (
            <Textarea
              {...field}
              label="Question 3"
              placeholder="Entrez la question 3"
              error={errors.question3?.message}
              minRows={3}
            />
          )}
        />
        <Controller
          name="question4"
          control={control}
          render={({ field }) => (
            <Textarea
              {...field}
              label="Question 4"
              placeholder="Entrez la question 4"
              error={errors.question4?.message}
              minRows={3}
            />
          )}
        />
        <Controller
          name="question5"
          control={control}
          render={({ field }) => (
            <Textarea
              {...field}
              label="Question 5"
              placeholder="Entrez la question 5"
              error={errors.question5?.message}
              minRows={3}
            />
          )}
        />
        <Controller
          name="question6"
          control={control}
          render={({ field }) => (
            <Textarea
              {...field}
              label="Question 6"
              placeholder="Entrez la question 6"
              error={errors.question6?.message}
              minRows={3}
            />
          )}
        />

        <Group justify="flex-end" mt="md">
          <Button variant="outline" onClick={onCancel} disabled={isSubmitting}>
            Annuler
          </Button>
          <Button type="submit" loading={isSubmitting}>
            Valider
          </Button>
        </Group>
      </Stack>
    </form>
  );
}
